// True when the device should use the phone layout. We gate purely on
// viewport width because pointer/hover media queries are unreliable on
// Windows touchscreen laptops: Chrome on those machines reports
// `pointer: coarse` and `any-pointer: coarse` and refuses to acknowledge
// the trackpad as a fine pointer, so any pointer-based test flips a real
// laptop to mobile. Width is the one signal we can trust across devices.
//
// Used by Header, Category, useCustomCursor, and Editor. Mirror this rule
// in any new mobile-vs-desktop branch — matching CSS rule is
// `(max-width: 1023px)`.
export default function isMobileLayout() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 1024;
}
